import React from "react";
import { connect } from 'react-redux';
import { Preloading as preloading } from '../../../components/UI/Preloader/action';
import { CardBody, Card, Label, Form, FormGroup, Col, Button, ModalHeader, ModalBody, ModalFooter } from 'reactstrap'
import { fetchMonitoringListRequest, downloadMonitoringCrawlerStatusFileRequest, downloadConsolidatedMonitoringReportRequest,
    fetchMonitoringCorporateListRequest, downloadCorporateMonitoringReportRequest,sendCorporateMonitoringReportRequest,sendCorporateMonitoringBulkReportRequest} from "./action";
import Select from 'react-select'
import { toast } from 'react-toastify';
import fileSaver from 'file-saver';
import moment from 'moment';
import TableView from "./table-view";
import { CRAWLER, REPORT } from "../constants";
import Modal from '../../../components/UI/Modal/Modal';
const CLOSE = "CLOSE";
const SUBMIT = "SUBMIT";
const CANCEL = "CANCEL";
const PROCEED = "PROCEED";

class MonitoringReport extends React.Component{

    state = {
        monitoringData: [],
        selectedOption: undefined,
        monitoringCorporateData : [],
        confirmModal: false
    };

    handleChange = (option) => {
        this.setState({ selectedOption: option })
    }

    componentDidUpdate(prevProps) {

        if(this.props.monitoringCorporateData !== prevProps.monitoringCorporateData){
            this.props.preloading(false);
            if (this.props.monitoringCorporateData.status === "SUCCESS") {
                if(this.props.monitoringCorporateData.data.length == 0){
                    toast.success(
                        <div>
                            <i ></i>&nbsp; {"No Corporates availble in monitoring !"};
                        </div>
                    )
                }
                this.setState({ monitoringCorporateData : this.props.monitoringCorporateData.data})
            }else{
                this.setState({monitoringCorporateData : []});
                toast.error(
                    <div>
                        <i className="fa fa-exclamation-triangle"></i>Please Try again !!
                    </div>
                );
            }
        }
        if (this.props.monitoringList !== prevProps.monitoringList) {
            let monitoringNameOptions = [];
            this.props.monitoringList && this.props.monitoringList.length > 0 &&
                this.props.monitoringList.map(monitoringObj => (
                    monitoringNameOptions = [
                        ...monitoringNameOptions, {
                            value: monitoringObj.id, label: monitoringObj.monitoringName
                        }
                    ]
                ))
            this.setState({ monitoringData: monitoringNameOptions, selectedOption: monitoringNameOptions.length > 0 ? monitoringNameOptions[0] : undefined },()=>{
                if(this.state.selectedOption && this.state.selectedOption.value){
                    this.props.fetchMonitoringCorporateListRequest({monitoringId : this.state.selectedOption.value});
                }
            })
        }

        if (this.props.consolidatedMonitoringReport !== prevProps.consolidatedMonitoringReport) {
            this.props.preloading(false);
            if (this.props.consolidatedMonitoringReport.status === "SUCCESS") {
                const data = this.props.consolidatedMonitoringReport.data;
                let blob = new Blob([data], { type: 'application/octet-stream' });
                let consolidateName = this.state.selectedOption.label;
                consolidateName = consolidateName.replace(/[&\/\\#, +()$~%.'":*?<>{}]/g, '_');
                fileSaver.saveAs(blob, `${"monitoring_report"}_${consolidateName}_${new Date().getTime()}.json`)
            } else if (this.props.consolidatedMonitoringReport.status === "FAILURE") {
                toast.error(
                    <div>
                        <i className="fa fa-exclamation-triangle"></i>Please Try again !!
                    </div>
                );
            }
        }

        if (this.props.monitoringCrawlerStatus !== prevProps.monitoringCrawlerStatus) {
            this.props.preloading(false);
            if (this.props.monitoringCrawlerStatus.status === "SUCCESS") {
                const data = this.props.monitoringCrawlerStatus.data;
                let blob = new Blob([data], { type: 'application/octet-stream' });
                fileSaver.saveAs(blob, `${"crawler_status_file"}_${this.state.selectedOption.label}_${moment().format("DD_MMM_YYYY")}.xlsx`)
            } else if (this.props.monitoringCrawlerStatus.status === "FAILURE") {
                toast.error(
                    <div>
                        <i className="fa fa-exclamation-triangle"></i>Please Try again !!
                    </div>
                );
            }
        }

        if (this.props.corporateMonitoringReport !== prevProps.corporateMonitoringReport) {
            this.props.preloading(false);
            console.log('in component update method of report download'+ this.props.corporateMonitoringReport.status)
            if (this.props.corporateMonitoringReport.status === "SUCCESS") {
                const data = this.props.corporateMonitoringReport.data;
                let blob = new Blob([data], { type: 'application/octet-stream' });
                fileSaver.saveAs(blob, `${"monitoring_report"}_${this.state.selectedOption.label}_${moment().format("DD_MMM_YYYY")}.xlsx`)
            } else if (this.props.corporateMonitoringReport.status === "FAILURE") {
                toast.error(
                    <div>
                        <i className="fa fa-exclamation-triangle"></i>Please Try again !!
                    </div>
                );
            }
        }
        if(this.props.sendCorporateMonitoringReport !== prevProps.sendCorporateMonitoringReport){
            this.props.preloading(false);
            if (this.props.sendCorporateMonitoringReport.status === "SUCCESS") {
                toast.success(
                    <div>
                        <i ></i>&nbsp; Mail Successfully Send!
                    </div>
                );
                
            } else {
                toast.error(
                    <div>
                        <i className="fa fa-exclamation-triangle"></i>&nbsp;{this.props.sendCorporateMonitoringReport.data.message}
                    </div>
                );
            }

        }
        
        if(this.props.sendMonitoringBulkReport !== prevProps.sendMonitoringBulkReport){
            this.props.preloading(false);
            if (this.props.sendMonitoringBulkReport.status === "SUCCESS") {
                toast.success(
                    <div>
                        <i ></i>&nbsp; Mail Successfully Send!
                    </div>
                );
                
            } else {
                toast.error(
                    <div>
                        <i className="fa fa-exclamation-triangle"></i>&nbsp;{this.props.sendMonitoringBulkReport.data.message}
                    </div>
                );
            }

        }
    }

    fetchCorporateList = (e) => {
        e.preventDefault();
        this.props.preloading(true);
        this.props.fetchMonitoringCorporateListRequest({monitoringId : this.state.selectedOption.value});
    } 

    downloadCorporateReportFile = (corporateId)=>{
            this.props.preloading(true);
            this.props.downloadCorporateMonitoringReportRequest({monitoringId : this.state.selectedOption.value, corporateId : corporateId});
    }

    sendCorporateReportEmail = (corporateId)=>{
        this.props.preloading(true);
        this.props.sendCorporateMonitoringReportRequest({monitoringId : this.state.selectedOption.value, corporateId : corporateId});
    }
    sendMonitoringReportEmail = ()=>{
        this.props.preloading(true);
        this.props.sendCorporateMonitoringBulkReportRequest({monitoringId : this.state.selectedOption.value});
    }
    downloadReport =(e)=>{
        e.preventDefault();
        this.props.preloading(true);
        this.props.downloadConsolidatedMonitoringReportRequest({monitoringId : this.state.selectedOption.value});
    }

    downloadCrawlerStatusFile =(e)=>{
        e.preventDefault();
        this.props.preloading(true);
        this.props.downloadMonitoringCrawlerStatusFileRequest({monitoringId : this.state.selectedOption.value});
    }

    componentDidMount() {
        this.props.fetchMonitoringListRequest();
       
    }
    handleModalToggle = () => {
        this.setState(prevState => ({
            showModal: !prevState.showModal,
            warning: ""
        }))
    }
    handleSendMonitoringMail = (e) => {
        this.setState({confirmModal:!this.state.confirmModal,monitoringId : this.state.selectedOption.value})
    }
    handleConfirmModalButton = (type) => {
        if (type === PROCEED) {
            this.sendMonitoringReportEmail();
            this.setState({ confirmModal: !this.state.confirmModal });
        }else if(type=== CLOSE){
            this.setState({ confirmModal: !this.state.confirmModal });
        }
        
    }

    render(){
        return(<Col>
         <Card>
                <CardBody >
                    <Form className="w-100" >
                        <FormGroup style={{ marginLeft: "1rem" }} row>
                            <Label sm={4}>Monitoring Name </Label>
                            <Col sm={4}>
                                <Select
                                    value={this.state.selectedOption}
                                    onChange={this.handleChange}
                                    options={this.state.monitoringData} />
                            </Col>
                            <Col style={{ marginLeft: "1rem" }} sm={4}>
                                <Button color="primary" onClick={(e) => this.handleSendMonitoringMail(e)}>Monitoring Emails</Button>
                            </Col>
                            <Col style={{ marginLeft: "1rem" }} sm={3}>
                                <Button color="primary" onClick={(e) => this.fetchCorporateList(e)}>Corporate List</Button>
                            </Col>
                            <Col style={{ marginLeft: "1rem" }} sm={4}>
                                <Button color="primary" onClick={(e) => this.downloadReport(e)}>Consolidated Report</Button>
                            </Col>
                            <Col style={{ marginLeft: "1rem" }} sm={3}>
                                <Button color="primary" onClick={(e) => this.downloadCrawlerStatusFile(e)}>Crawler Status</Button>
                            </Col>
                        </FormGroup>
                        <Modal show={this.state.confirmModal} className="serveron-confirm-modal Large-Modal" >
                            <ModalHeader>
                                Monitoring Mail 
                            </ModalHeader>
                            <ModalBody>
                                Are You Sure You Want to Send Mail ?
                            </ModalBody>
                            <ModalFooter>
                                <Col><Button color="success" size="lg" className="justify-content-center" onClick={() => this.handleConfirmModalButton(PROCEED)}> Proceed </Button></Col>
                                <Col ><Button color="info" size="lg" className="justify-content-center" onClick={() => this.handleConfirmModalButton(CLOSE)} > Cancel </Button></Col>
                            </ModalFooter>
                        </Modal>
                    </Form>
                </CardBody>
            </Card>
            
            { this.state.monitoringCorporateData && this.state.monitoringCorporateData.length > 0 &&
             <Card>
                <CardBody>
                    <TableView  monitoringCorporateData = {this.state.monitoringCorporateData} downloadFile = {this.downloadCorporateReportFile} sendMonitoringEmail= {this.sendCorporateReportEmail} />
                </CardBody>
            </Card>}
        </Col>)
    }
}



const mapStateToProps = (state) => ({
    monitoringList: state.monitoringData.monitoringList,
    consolidatedMonitoringReport: state.monitoringData.consolidatedMonitoringReport,
    monitoringCrawlerStatus: state.monitoringData.monitoringCrawlerStatus,
    monitoringCorporateData : state.monitoringData.monitoringCorporateList,
    corporateMonitoringReport: state.monitoringData.corporateMonitoringReport,
    sendCorporateMonitoringReport : state.monitoringData.sendCorporateMonitoringReport,
    sendMonitoringBulkReport : state.monitoringData.sendMonitoringBulkReport
})

const mapDispatchToProps = (dispatch) => ({
    preloading: data => { dispatch(preloading(data)) },
    fetchMonitoringListRequest : data => {dispatch(fetchMonitoringListRequest(data))},
    downloadConsolidatedMonitoringReportRequest : data => {dispatch(downloadConsolidatedMonitoringReportRequest(data))},
    downloadMonitoringCrawlerStatusFileRequest : data => {dispatch(downloadMonitoringCrawlerStatusFileRequest(data))},
    fetchMonitoringCorporateListRequest : data => {dispatch(fetchMonitoringCorporateListRequest(data))},
    downloadCorporateMonitoringReportRequest : data => {dispatch(downloadCorporateMonitoringReportRequest(data))},
    sendCorporateMonitoringReportRequest : data => {dispatch(sendCorporateMonitoringReportRequest(data))},
    sendCorporateMonitoringBulkReportRequest : data => {dispatch(sendCorporateMonitoringBulkReportRequest(data))}
});

export default connect(mapStateToProps, mapDispatchToProps)(MonitoringReport);